module.exports = "pegasus_template/assets/theme6/medium/9.jpg";